<div class="prizm-navigation-menu-search">
  <prizm-input-layout class="prizm-navigation-menu-search__input" label="" size="m">
    <input #searchInput [formControl]="searchFormControl" [placeholder]="placeholder || ''" prizmInput />
    <ng-container prizm-input-right>
      <button prizmInputIconButton="sort-zoom-in"></button>
    </ng-container>
  </prizm-input-layout>
</div>
